import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class BitesizeSessionViewService {

  cachedResource: any;
  cacheTime = new Date();
  cacheLifetime = 1 * 60 * 1000;

  constructor(private http: HttpClient) {}

  fetchAll() {
    return this.http
      .get<any>(environment.apiUrl + '/bitesize_session_views', {
        responseType: 'json',
      })
      .pipe(
        map((responseData) => {
          const resourcesArray: any = [];
          responseData['_embedded'].bitesize_session_views.forEach((resource: any) => {
            resourcesArray.push(resource);
          });
          return resourcesArray;
        }),
        catchError((errorRes) => {
          return throwError(errorRes);
        })
      );
  }

  save(bitesize_session_id:any) {
    this.clearCache();
    const postData = {
      bitesize_session_id
    };
    return this.http.post<any>(
      environment.apiUrl + '/bitesize_session_views',
      postData,
      {
        observe: 'response',
      }
    );
  }

  clearCache() {
    this.cachedResource = null;
  }

  checkViewed(bitesize_session_views:any, bitesize_session_id:any){
    let viewed = false;
    bitesize_session_views.forEach((bitesize_session_view:any)=>{
      if(bitesize_session_view.bitesize_session_id == bitesize_session_id){
        viewed = true;
      }
    });

    return viewed;
  }
}
